import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Component, OnInit, Input } from '@angular/core';
import { catchError, delay, Observable, of, retryWhen, switchMap } from 'rxjs';
import { User } from '../models/user';
import { AuthService } from '../services/authService';

@Component({
    selector: 'app-navigation',
    templateUrl: './navigation.component.html',
    styleUrl: './navigation.component.scss',
    standalone: false
})
export class NavigationComponent implements OnInit {
  user = new User('', false);
  menuIcon: any;
  http!: HttpClient;
  response?: any;
  errorList = document.createElement('ul');
  errorTitle?: string;
  private httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
  };

  constructor(http: HttpClient, private authService: AuthService) {
    this.http = http;
  }

  async ngOnInit() {
    const isLoggedIn = await this.checkIfUserIsLoggedIn();

    this.menuIcon = document.getElementById('menuIcon');

    this.menuIcon.addEventListener('click', () => {
      const checkbox = document.getElementById('navi-toggle') as HTMLInputElement;
      if (checkbox.classList.contains('checked')) {
        checkbox.classList.remove('checked');
      } else {
        checkbox.classList.add('checked');
      }
    });

    const naviToggle = document.getElementById('navi-toggle') as HTMLInputElement;
    naviToggle.addEventListener('change', async () => {
      await this.checkIfUserIsLoggedIn();
    });
  }

  // Todo: write sad path unit tests for this method
  // Todo: write happy path unit tests for this method
  private checkIfUserIsLoggedIn(): Promise<boolean> {
    return new Promise((resolve) => {
      this.authService.isLoggedIn().pipe(
        retryWhen(errors =>
          errors.pipe(
            switchMap((error) => {
              console.error('Error occurred:', error.message);
              // Retry only if the error status is 500
              if (error.status === 500) {
                return of(error).pipe(delay(1000));
              }
              // If the error is not 500, throw the error
              throw error;
            })
          )
        ),
        catchError((error) => {
          console.error('Final error after retries:', error);
          return of({ isAuthenticated: false, userName: '' });
        })
      ).subscribe((response: any) => {
        this.user.loggedin = response.isAuthenticated;
        this.user.username = response.userName ?? "";
        resolve(this.user.loggedin);
      });
    });
  }

  // Todo: write sad path unit tests for this method
  // Todo: write happy path unit tests for this method
  logoutUser(): void {
    const headers = new HttpHeaders().set('Content-Type', 'application/json; charset=utf-8');
    //debugger;
    this.http.post('/api/Account/logout', {
      headers: headers,
    })
      .pipe(catchError(this.handleError<any>('logoutUser')))
      .subscribe({
        next: (response) => {
          this.response = response;
          if (!response) {
            console.error("response is undefined");
          }
          else if (response?.success == false) {
            for (let errorMessage = 0; errorMessage < response.errorMessages.length; errorMessage++) {
              console.error(response.errorMessages[errorMessage]);
            }
          } else {
            // redirect to /
            window.location.href = '';
          }
        },
        error: (error) => {
          this.response = error;
          console.error(error.message);
        },
      });
  }

  // Todo: write sad path unit tests for this method
  // Todo: write happy path unit tests for this method
  private handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {
      if (error.error) {
        this.errorTitle = error.error.title;
      }

      return of(result as T);
    };
  }
}
